import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
} from "@mui/material";
import leftarrow from "../../assets/arrowicons/Vector 524.svg"
import rightarrow from "../../assets/arrowicons/Vector 523.svg"
import { Tooltip } from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const TimeSeriescards = ({ timeSeriesCards = [] }) => {
  return (
    <Grid container rowSpacing={2}
      columnSpacing={{ xs: 1, sm: 1.5, md: 2 }} sx={{ mt: 0 }}>
      {timeSeriesCards?.map((card, i) => (
        <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={i} sx={{ paddingTop: "26px !important" }}>
          <Card
            sx={{
              borderRadius: "4px",
              background: "#fff",
              boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              position: "relative",
              paddingTop: "30px",
              minWidth: 0
            }}
          >
            {/* HEADER */}
            <Box
              sx={{
                position: "absolute",
                top: "-10px",
                left: { xs: "8px", sm: "12px", md: "16px" },
                right: { xs: "8px", sm: "12px", md: "16px" },
                height: "40px",
                background: "#115f9c",
                borderRadius: "4px !important",
                display: "flex",
                alignItems: "center",
                px: { xs: 1, sm: 1.5, md: 2 },
                color: "#fff",
                fontSize: { xs: "12px", sm: "13px", md: "16px" },
                fontWeight: 200,
                whiteSpace: "nowrap",
                overflow: "hidden",
                pl: "12px",
                pr: "12px",
                textOverflow: "ellipsis",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", flex: 1, minWidth: 0, overflow: "hidden" }}>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "11px", sm: "12px", md: "16px" },
                    fontWeight: 200,
                    mr: "6px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                  }}
                >
                  {card.title}
                </Typography>

                <Tooltip
                  title="Calculated from the latest fully closed period; no open-period data included."
                  placement="right"
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        backgroundColor: "#1f1f1f",
                        color: "#fff",
                        fontSize: "12px",
                        padding: "8px 12px",
                        borderRadius: "6px",
                        maxWidth: "260px",
                      },
                    },
                    arrow: {
                      sx: {
                        color: "#1f1f1f",
                      },
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: card.showIndicator ? 8 : 0,
                      height: card.showIndicator ? 8 : 0,
                      borderRadius: "50%",
                      cursor: "pointer",
                      backgroundColor:"#11C634"
                        // card.values.some(v => v.status === "decrease")
                        //   ? "#d9534f"
                        //   : card.values.some(v => v.status === "increase")
                        //     ? "#11C634"
                        //     : "#cccccc",
                    }}
                  />
                </Tooltip>
              </Box>
            </Box>

            {/* CONTENT */}
            <CardContent sx={{ overflowX: "auto" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  minWidth: "fit-content",

                }}
              >
                {card.values.map((v, idx) => (
                  <React.Fragment key={idx}>
                    {/* VALUE COLUMN */}
                    <Box sx={{ textAlign: "center", flex: 1 }}>
                      {/* TIME LABEL */}
                      <Chip
                        label={v.label}
                        sx={{
                          background:
                            v.status === "increase"
                              ? "#107D25"
                              : v.status === "decrease"
                                ? " #FF565C"
                                : v.status === "nochange"
                                  ? "#115F9C"
                                  : "transparent",
                          color: "#fff",
                          fontSize: "10px",
                          height: "24px",
                          mb: "12px",
                          borderRadius: "4px",
                          // padding: "12px"
                          "& .MuiChip-label": {
                            padding: "0px 6px !important",
                          },
                          fontWeight: 300,
                          height: "20px"
                        }}
                      />

                      {/* CURRENT VALUE */}
                      <Typography
                        sx={{
                          fontSize: "20px",
                          fontWeight: '200',
                          lineHeight: 1,
                          color: "#111111",
                        }}
                      >
                        {v.value}
                      </Typography>
                    </Box>


                    {/* SPACER BETWEEN PERIODS */}
                    {idx < card.values.length - 1 && (() => {
                      const current = v;
                      const next = card.values[idx + 1];

                      // If neither side has delta info, render nothing
                      if (!current.change && !current.arrow && !next.change && !next.arrow) {
                        return null;
                      }

                      // Decide which data to show
                      const showChange = current.arrow === "right"
                        ? current.change
                        : next.arrow === "left"
                          ? next.change
                          : null;

                      const arrowDirection = current.arrow === "right"
                        ? "right"
                        : next.arrow === "left"
                          ? "left"
                          : null;

                      const status = current.arrow === "right"
                        ? current.status
                        : next.status;

                      if (!showChange && !arrowDirection) return null;
                      const numericChange = parseFloat(showChange?.replace("%", ""));
                      const isPositive = !isNaN(numericChange) && numericChange >= 0;

                      return (
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            px: 0.5,
                            minWidth: "50px",
                            pt: '6px',
                          }}
                        >
                          {/* % CHANGE */}

                          {showChange && (

                            <Typography
                              sx={{
                                fontSize: "15px",
                                fontWeight: 300,
                                color:
                                  status === "increase"
                                    ? "#107D25"
                                    : status === "decrease"
                                      ? "#FF565C"
                                      : "#107D25",
                              }}
                            >
                              {showChange}
                            </Typography>
                          )}

                          {/* ARROW */}
                          {arrowDirection === "right" && (
                            <img src={rightarrow} alt="" width={24} height={24} />
                          )}
                          {arrowDirection === "left" && (
                            <img src={isPositive ? rightarrow : leftarrow} alt="" width={24} height={24} style={{
                              transform: isPositive ? "rotate(180deg)" : "rotate(0deg)",
                              transition: "transform 0.2s ease",
                            }} />
                          )}
                        </Box>
                      );
                    })()}


                  </React.Fragment>
                ))}
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default TimeSeriescards;
